import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { trackAddToCart } from '../../hooks/useMetaPixel';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden px-4" data-id="element-96">
      {/* Decorative background blur */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-sage-300/30 rounded-full blur-3xl -z-10" data-id="element-97"></div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-99">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-100">
            El Protocolo de Emergencia para{' '}
            <span className="text-sage-500 italic" data-id="element-101">Desinflamar tu Vientre</span>{' '}
            en 48 Horas
          </h1>
          <p className="text-lg md:text-xl text-forest/80 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-102">
            (Sin Dietas Extremas ni Ejercicio Agotador). Recupera la confianza
            para usar ese vestido y desactiva la hinchazón por estrés con el
            Método de Descompresión Dual.
          </p>

          <div className="flex flex-col items-center lg:items-start space-y-4" data-id="element-103">
            <div className="flex items-center gap-3 mb-1" data-id="element-104">
              <span className="text-xl md:text-2xl text-forest/35 line-through" data-id="element-105">
                $19.99
              </span>
              <span className="bg-gold-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-106">
                -68%
              </span>
              <span className="text-2xl md:text-3xl font-bold text-forest" data-id="element-107">
                $6.39{' '}
                <span className="text-base font-normal text-forest/50" data-id="element-108">
                  USD
                </span>
              </span>
            </div>
            <Button className="w-full sm:w-auto text-lg px-10 py-5" onClick={() => {
            trackAddToCart();
            window.open('https://temptbeuty.com/cart/56832850591904:1', '_blank');
          }} data-id="element-109">
              ¡SÍ! QUIERO DESINFLAMAR MI VIENTRE AHORA
            </Button>
            <p className="text-sm text-forest/60 flex items-center" data-id="element-110">
              <svg className="w-4 h-4 mr-2 text-gold-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-111">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-112" />
              </svg>
              Acceso instantáneo después del pago. Tu confianza no tiene precio.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-113">
          <div className="absolute inset-0 bg-gradient-to-tr from-sage-400/20 to-transparent rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-114"></div>
          <img src="https://cdn.magicpatterns.com/uploads/mDQEt6LbBPQhvcVaYeMLzf/Vientre_Plano.png" alt="Protocolo Vientre Plano 48H en dispositivos" className="w-full h-auto rounded-2xl shadow-soft object-cover" data-id="element-115" />
        </motion.div>
      </div>
    </section>;
}